import tw, { styled } from 'twin.macro';

export const SearchStateInfoContainer = styled.div`
  ${tw`flex flex-col items-center gap-y-6`}
`;

export const LoaderImage = styled.img`
  ${tw`mx-auto`}
  width: 140px;
  height: 140px;
`;
